
import { useTheme } from "@/components/ThemeProvider";
import { useEffect, useState } from "react";
import { Card } from "@/components/ui/Card";

const APPEARANCE_OPTIONS = [
  { value: "system", label: "Auto" },
  { value: "light", label: "Light" },
  { value: "dark", label: "Dark" },
] as const;

type AppearanceTheme = (typeof APPEARANCE_OPTIONS)[number]["value"];

export function AppearanceCard() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const selectedTheme: AppearanceTheme =
    mounted && theme === "light"
      ? "light"
      : mounted && theme === "dark"
        ? "dark"
        : "system";

  return (
    <Card title="Appearance" subtitle="Interface color mode.">
      <div
        className="inline-flex rounded-lg border border-zinc-200 bg-zinc-50 p-0.5 dark:border-border dark:bg-surface-2"
        role="radiogroup"
        aria-label="Appearance"
      >
        {APPEARANCE_OPTIONS.map((option) => {
          const selected = mounted && selectedTheme === option.value;
          return (
            <button
              key={option.value}
              type="button"
              role="radio"
              aria-checked={selected}
              disabled={!mounted}
              onClick={() => setTheme(option.value)}
              className={[
                "min-w-20 rounded-md px-3 py-1.5 text-[12px] font-medium transition disabled:cursor-default",
                selected
                  ? "bg-white text-zinc-900 shadow-sm dark:bg-surface dark:text-zinc-100"
                  : "text-zinc-500 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-200",
              ].join(" ")}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </Card>
  );
}
